(async function(){
  const id=new URLSearchParams(location.search).get('du_fit');
  const host=document.querySelector('[data-du-reference-fields]');
  if(!id||!host)return;
  // Confirmation follows this browser session, never an unconfirmed shared link.
  try{if(sessionStorage.getItem('du-confirmed-fit')!==id)return;}catch(_){return;}
  const product=host.dataset.duProductId;
  if(!['7279270789155','7191581949987'].includes(product))return;
  const config=document.querySelector('[data-du-product-records]');
  if(!config)return;
  try{
    const response=await fetch(config.dataset.duProductRecords);if(!response.ok)return;
    const data=await response.json(); let record=data.records.find(r=>r.id===id);
    if(id.startsWith('fitted-')){try{const saved=JSON.parse(sessionStorage.getItem('du-fitted-record'));if(saved?.id===id)record=saved;}catch(_){}}
    if(!record||!record.length||!record.width)return;
    const description=[record.make,record.model,record.year,record.cab,record.setup].join(' · ');
    const values={'Vehicle Description':record.make+' '+record.model,'Tub width (mm) — entered by you':record.width,'Tub length (mm) — entered by you':record.length,'Wheel arch width (mm) — entered by you':record.arch};
    const inputs=Array.from(host.querySelectorAll('input[name^="properties["]'));
    if(inputs.some(input=>!values[input.name.slice(11,-1)]))return;
    inputs.forEach(input=>{
      const key=input.name.slice(11,-1);
      input.value=String(values[key]);input.readOnly=true;
      if(key!=='Vehicle Description')input.name='properties[_'+key.replace(' — entered by you','')+']';
    });
    const summary=document.createElement('div');summary.className='du-selected-summary';
    const title=document.createElement('strong');title.textContent='Your ute is confirmed. No measuring needed.';
    const text=document.createElement('p');text.textContent=description;
    const link=document.createElement('a');const url=new URL((window.Shopify?.routes?.root||'/')+'collections/all',location.origin);url.searchParams.set('view','dv-vehicles');url.searchParams.set('du_fit',id);link.href=url.pathname+url.search;link.textContent='Change vehicle';
    summary.append(title,text,link);host.before(summary);host.hidden=true;
    Object.entries({'Year / series':record.year,'Cab':record.cab,'Tub setup':record.setup}).forEach(([name,value])=>{
      if(!value)return;
      const detail=document.createElement('input');detail.type='hidden';detail.name='properties['+name+']';detail.value=value;detail.setAttribute('form','product-form-'+product);host.append(detail);
    });
    const input=document.createElement('input');input.type='hidden';input.name='properties[_Fitment reference]';input.value=record.id;input.setAttribute('form','product-form-'+product);host.append(input);
  }catch(_){} // A failed lookup leaves the existing form available.
})();
